module.exports = __webpack_public_path__ + "static/media/16-4.3ce0fa2a.mp3";